import { connect } from 'react-redux';
import { toggleChildrenDisplay } from 'Favourites/store/actions';
import { LIST_TYPE } from 'Favourites/store/constants';
import { selectProduct } from 'Favourites/store/reducers/data/products';

const mapStateToProps = (state, ownProps) => {
    return {
        parentArticle: ownProps.parentArticle,
        parts: selectProduct(state, ownProps.parentArticle).childProducts,
        showChildren: selectProduct(state, ownProps.parentArticle).showChildren || false,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        toggleDisplay: (article, value) => {
            dispatch(toggleChildrenDisplay(article, value, LIST_TYPE));
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps);
